import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "word-cloud-api",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#word-cloud-api",
        "aria-label": "word cloud api permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Word Cloud API`}</h1>
    <p><img parentName="p" {...{
        "src": "./word_cloud.png",
        "alt": "alt text",
        "title": "Logo Title Text 1"
      }}></img></p>
    <p>{`With word cloud API you can easily create word clouds by sending a request with your text and configuration options.`}</p>
    <p>{`Word Cloud API is available on `}<a parentName="p" {...{
        "href": "https://rapidapi.com/Textvis/api/word-cloud/"
      }}>{`RapidAPI marketplace`}</a></p>
    <h2 {...{
      "id": "configuration-options",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#configuration-options",
        "aria-label": "configuration options permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Configuration options`}</h2>
    <ul>
      <li parentName="ul">{`Customize the size of your word cloud`}</li>
      <li parentName="ul">{`Choose the colors you want`}</li>
      <li parentName="ul">{`Include or exclude `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Stop_words"
        }}>{`stop words`}</a>{` for different languages`}</li>
    </ul>
    <br />
    <p><a parentName="p" {...{
        "href": "/getting-started"
      }}>{`Getting started`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      